import {
    RecoleccionActionTypes,
    IRecoleccion,
    SET_RECOLECCION_ORIGEN,
    SET_RECOLECCION_DESTINO
} from "../types/recoleccionActionTypes";

export function setRecoleccionOrigen (recoleccion: IRecoleccion): RecoleccionActionTypes {
    return {
        type: SET_RECOLECCION_ORIGEN,
        recoleccion
    }
}

export function setRecoleccionDestino (recoleccion: IRecoleccion): RecoleccionActionTypes {
    return {
        type: SET_RECOLECCION_DESTINO,
        recoleccion
    }
}


